module.exports = __webpack_public_path__ + "static/avatar@2x-7eee7453a8a2aa5219c792e63e709a3a.jpg";